import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-bootstrap4';
import Select from 'react-select';
import moment from 'moment';

import { DataContext as CoveringTableContext } from '../../../stores/covering-table-store';
import { DataContext } from '../../../store';

import CustomSelect from '../shared/CustomSelect';
import {
    InputDebouncer,
    HandleStatusOptions,
    HandleCustomOptions,
    officesArr,
    regionArr,
} from '../shared/FilterEventHelpers';
import WeekHelper from '../../../functions/WeekHelper';

import { useTranslation } from 'react-i18next';
import { EMP_IS_WORKING, EMP_HAS_QUIT, EMP_WILL_START, SHOW_ALL } from '../../../i18n/keyConstants';
import { translateOptionLabel } from '../../exl/shared/translations';

const FilterCell = ({ column, children, ...restProps }) => {
    const {
        store: { offices },
    } = useContext(DataContext);

    const {
        store: { selectedOffice, selectedRegion, selectedStatus, selectedFilters, isResettingFilters, filters },
        dispatch,
    } = useContext(CoveringTableContext);
    const columnName = column.name;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [chosenValue, setChosenValue] = useState(selectedFilters[columnName]);
    const intervalRef = useRef(null);

    const { t } = useTranslation(['shared']);
    
    useEffect(() => {
        if (IsTextInputColumn()) {
            if (!(chosenValue === selectedFilters[columnName])) {
                return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenValue]);

    useEffect(() => {
        return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children[0].props.value]);

    useEffect(() => {
        if (isResettingFilters) {
            setChosenValue('');
            dispatch({
                type: 'SELECTED_FILTERS_AND_FILTERS_RESET',
                columnName: columnName,
                payload: '',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);

    const IsTextInputColumn = () => {
        const weekNum = parseInt(columnName);
        return columnName !== 'office' && columnName !== 'regionName' && isNaN(weekNum);
    };

    const getRegionsFromOffices = (offices) => {
        let regions = [];
        for (var o in offices) {
            var off = offices[o];
            if (!off.region) {
                // Missing region
                continue;
            }
            const regId = off.region.id;
            if (regions.findIndex(r => r.id === regId) >= 0) {
                // Already added
                continue;
            }
            regions.push(off.region);
        }
        let regionsArray = regions.map((option) => ({ value: option.id, label: option.name }));
        regionsArray.sort((a, b) => (a.label > b.label) ? 1 : (b.label > a.label) ? -1 : 0);
        regionsArray.push({ value: "TheRegionless", label: "Övriga" });
        return regionsArray;
    };

    const handleSelectValueChange = (selected) => {
        if (columnName === 'regionName') {
            dispatch({ type: 'SELECTED_REG', payload: selected });
        } else if (columnName === 'office') {
            dispatch({ type: 'SELECTED_OFFICE', payload: selected });
        }
    };

    useEffect(() => {
        if (window.location.search) {
            if (columnName === 'regionName') {
                dispatch({ type: 'SELECTED_REG', payload: regionArr });
            }
            if (columnName === 'office') {
                dispatch({ type: 'SELECTED_OFFICE', payload: officesArr });
            }
        }

    }, []);

    const weekNum = parseInt(columnName.slice(4));

    if (weekNum >= 1 && weekNum <= 53) {
        const columnWeekDate = moment(WeekHelper.GetMondayDateOfWeek(columnName)).format('DD/MM').toString();
        return (
            <TableFilterRow.Cell className='no-bold no-selectable-cell-text' column={column} {...restProps}>
                {columnWeekDate}
            </TableFilterRow.Cell>
        );

    } else if (columnName === 'status') {
        return (
            <th>
                <Select
                    isClearable={false}
                    isMulti
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={translateOptionLabel(selectedStatus, t) }
                    options={[
                        { label: t(EMP_IS_WORKING), value: 'isWorking' },
                        { label: t(EMP_WILL_START), value: 'willStart' },
                        { label: t(EMP_HAS_QUIT), value: 'hasQuit' },
                        { label: t(SHOW_ALL), value: 'showAll' },
                    ]}
                    onChange={(e) => {
                        HandleStatusOptions(e, filters, selectedStatus, handleSelectValueChange, dispatch);
                    }}
                />
            </th>
        );
    } else if (columnName === 'office') {
        return (
            <CustomSelect
                {...restProps}
                columnName='office'
                options={offices && offices.map((option) => ({ value: option.name, label: option.name }))}
                selected={selectedOffice}
                onSelectedChange={(selected) => HandleCustomOptions(selected, filters, 'office', handleSelectValueChange, dispatch)}
            />
        );
    } else if (columnName === 'regionName') {
        const regions = getRegionsFromOffices(offices);
        return (
            <CustomSelect
                {...restProps}
                columnName='regionName'
                options={regions}
                selected={selectedRegion}
                onSelectedChange={(selected) => HandleCustomOptions(selected, filters, 'regionName', handleSelectValueChange, dispatch)}
            />
        );
    }

    var FilterOptions = children[0];
    var TextInput = React.cloneElement(children[1], {
        value: chosenValue,
        onChange: (event) => {
            setChosenValue(event);
            children[1].props.onChange();
        },
    });

    return (
        <TableFilterRow.Cell id={column.name + '-filter'} column={column} {...restProps}>
            {FilterOptions}
            {TextInput}
        </TableFilterRow.Cell>
    );
};

export default FilterCell;
